/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/

import school from './school.js'
import settings from './settings';
// import cashflow from './cashflow';
import finance from './finance';
import role from './role';
import admin from './admin';
import report from './report';
// import revenues from './revenues';
// import expenses from './expenses';
// import account from './account';
// import fund from './fund';

const userData = JSON.parse(localStorage.getItem('userData') || '{}');
if (userData.id === 198) finance.push({
  title: 'Hóa đơn Pancake POS',
  route: 'pos',
  icon: 'ArchiveIcon',
  resource: 'invoice',
  action: 'read',
})

// Array of sections
export default [
  // ...revenues,
  // ...expenses,
  // ...cashflow,
  // ...account,
  // ...finance,
  // // ...report,
  // ...fund,
  // ...settings,

  //==============================================================================================================

  ...school,
  ...finance,
  ...report,
  ...role,
  ...settings,
  ...admin,

];
